import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-setting-field-booking-window-timezone',
    templateUrl: './editor-booking-item-setting-field-booking-window-timezone.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingFieldBookingWindowTimezoneComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  tzNames: { id: string, name: string }[];
  filteredTzNames: Observable<{ id: string, name: string }[]>;

  constructor(private editorData: EditorDataService) {
    this.tzNames = this.editorData.tzNames;
  }

  ngOnInit() {
    this.filteredTzNames = this.parentFormGroup.controls['timezone'].valueChanges.pipe(
      startWith(undefined),
      map(value => this.filterTzNames(this.tzNames, value)),
      takeUntil(this.destroyed$)
    );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private filterTzNames(tzNames: { id: string, name: string }[], value: string): { id: string, name: string }[] {
    if (value === undefined) {
      return tzNames;
    }

    const filterValue = value.toUpperCase();
    return tzNames.filter(tzName => tzName.name.toUpperCase().includes(filterValue));
  }
}
